import { Component, inject, input, output, HostListener, ViewEncapsulation } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { ModalRef } from './modal-ref';

@Component({
  selector: 'app-modal',
  standalone: true,
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ModalComponent {
  private themeService = inject(ThemeService);
  private modalRef = inject(ModalRef, { optional: true });
  readonly isDark = this.themeService.isDark;

  title = input('');
  width = input('');
  maxWidth = input('');
  hideClose = input(false);

  close = output<void>();

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.close.emit();
    this.modalRef?.close();
  }

  onOverlayClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('app-modal__overlay')) {
      this.close.emit();
      this.modalRef?.close();
    }
  }

  onClose(): void {
    this.close.emit();
    this.modalRef?.close();
  }
}
